export var userCrosswalk98812 = {
    eolsId: 98812,
    externalUserId: 86799,
    userName: 'itesting',
    type: 'evolve',
    userData: '{"firstName":"Instructor","lastName":"Testing","email":"evolveadmin-servicesITEST@elsevier.com","alternateEmail":null,"roles":["faculty_registered","faculty"],"institutionId":null,"userInstitution":{"country":"US","state":"MO","city":"Saint Louis","name":"Elsevier","institutionId":"442641"},"userId":1228393,"userName":"itesting"}',
    eolsUserIdsByUserNameAndType: [98812, 979826]
};
